import { Chart, DataSource, Layout, } from "@mcleod/components";

export abstract class AutogenLayoutWidgetOrderSummaryByDeliveryDate extends Layout {
    chartOrderCount: Chart;
    sourceOrderSummaryByDeliveryDate: DataSource;
}
